export const paginationSettings = {
 permissionList: {
    prefix: "permissionList",
    defaultPageSize: 20,
  },
};
